<template>
  <div class="mainTabs">
    <input id="tabKichos" type="radio" name="tabs" checked />
    <label class="check-radio taekwondo" for="tabKichos">Kichos</label>

    <input id="tabOther" type="radio" name="tabs" />
    <label class="check-radio documents" for="tabOther">Otros</label>

    <section id="content1">
      <product-grid-item
        v-for="(itemGridBack, index) in 3"
        :key="itemGridBack[index]"
        :columns="3"
        :titleLabel="$t(`label.learningView.kichos.${index + 1}.title`)"
        :urlYoutube="urlYoutubeKichos[index + 1].url"
      ></product-grid-item>
      <product-grid-item
        v-for="(itemGridTop, index) in 3"
        :key="itemGridTop[index]"
        :columns="3"
        :titleLabel="$t(`label.learningView.kichos.${index + 4}.title`)"
        :urlYoutube="urlYoutubeKichos[index + 4].url"
      ></product-grid-item>
      <product-grid-item
        v-for="(itemGridTop, index) in 1"
        :key="itemGridTop[index]"
        :columns="2"
        :titleLabel="$t(`label.learningView.kichos.${index + 7}.title`)"
        :urlYoutube="urlYoutubeKichos[index + 7].url"
      ></product-grid-item>
    </section>

    <section id="content2">
      <product-grid-item
        v-for="(itemGridBack, index) in 3"
        :key="itemGridBack[index]"
        :columns="3"
        :titleLabel="$t(`label.learningView.other.${index + 1}.title`)"
        :urlYoutube="urlYoutubeOther[index + 1].url"
      ></product-grid-item>
      <product-grid-item
        v-for="(itemGridTop, index) in 3"
        :key="itemGridTop[index]"
        :columns="3"
        :titleLabel="$t(`label.learningView.other.${index + 4}.title`)"
        :urlYoutube="urlYoutubeOther[index + 4].url"
      ></product-grid-item>

    </section>
  </div>
</template>

<script>
import ProductGridItem from "@/components/product-grid-item/ProductGridItem.vue";
import CONSTANTS from "./constants.js";
export default {
  name: "Learning",

  components: {
    ProductGridItem,
  },
  computed: {
    columnsTop() {
      return 3;
    },
    columnsMiddle() {
      return 3;
    },
    columnsBack() {
      return 3;
    },
    urlYoutubeKichos() {
      return CONSTANTS.URLS_YOUTUBE_KICHOS;
    },
    urlYoutubeOther() {
      return CONSTANTS.URLS_YOUTUBE_OTHER;
    }
  },
};
</script>

<style>

input#tabKichos {
  display: none;
}

input#tabOther {
  display: none;
}

#tabKichos:checked ~ #content1 {
  display: block;
  border: none;
  margin-top: 180px;
}

#tabOther:checked ~ #content2 {
  display: block;
  border: none;
  margin-top: 180px;
}

@media screen and (max-width: 833px) {
  #tabKichos:checked ~ #content1 {
    margin-top: 175px;
  }
  #tabOther:checked ~ #content2 {
    margin-top: 175px;
  }

  label.check-radio:before {
    margin: 0;
    font-size: 18px;
  }
}

@media (max-width: 750px) {
  #tabKichos:checked ~ #content1 {
    margin-top: 140px;
  }
  #tabOther:checked ~ #content2 {
    margin-top: 140px;
  }
}
</style>
